module.exports = __webpack_public_path__ + "static/media/multi-image-2.e10a8e3c.png";